import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useStringValueInputHandlers from '../../Hooks//UseStringValueInputHandlers';
import { Size } from '../../Constants/System';
import { mergeWithDefaults } from '../../Utility/PropUtils';
import ValidationSection, { getValidationState, ValidationDisplay } from './ValidationSection';
import SimpleInput from './SimpleInput';
export var InputType;
(function (InputType) {
    InputType["text"] = "text";
    InputType["email"] = "email";
    InputType["password"] = "password";
    InputType["number"] = "number";
    InputType["time"] = "time";
    InputType["date"] = "date";
})(InputType || (InputType = {}));
// See https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
export var AutoComplete;
(function (AutoComplete) {
    AutoComplete["off"] = "off";
    AutoComplete["on"] = "on";
    AutoComplete["name"] = "name";
    AutoComplete["honorificPrefix"] = "honorific-prefix";
    AutoComplete["givenName"] = "given-name";
    AutoComplete["additionalName"] = "additional-name";
    AutoComplete["familyName"] = "family-name";
    AutoComplete["honorificSuffix"] = "honorific-suffix";
    AutoComplete["nickname"] = "nickname";
    AutoComplete["email"] = "email";
    AutoComplete["username"] = "username";
    AutoComplete["newPassword"] = "new-password";
    AutoComplete["currentPassword"] = "current-password";
    AutoComplete["oneTimeCode"] = "one-time-code";
    AutoComplete["organizationTitle"] = "organization-title";
    AutoComplete["organization"] = "organization";
    AutoComplete["streetAddress"] = "street-address";
    AutoComplete["addressLine1"] = "address-line1";
    AutoComplete["addressLine2"] = "address-line2";
    AutoComplete["addressLine3"] = "address-line3";
    AutoComplete["country"] = "country";
    AutoComplete["countryName"] = "country-name";
    AutoComplete["postalCode"] = "postal-code";
    AutoComplete["transactionAmount"] = "transaction-amount";
    AutoComplete["bday"] = "bday";
    AutoComplete["bdayDay"] = "bday-day";
    AutoComplete["bdayMonth"] = "bday-month";
    AutoComplete["bdayYear"] = "bday-year";
    AutoComplete["sex"] = "sex";
    AutoComplete["tel"] = "tel";
    AutoComplete["telCountryCode"] = "tel-country-code";
    AutoComplete["telNational"] = "tel-national";
    AutoComplete["telAreaCode"] = "tel-area-code";
    AutoComplete["telLocal"] = "tel-local";
    AutoComplete["telExtension"] = "tel-extension";
    AutoComplete["url"] = "url";
    AutoComplete["photo"] = "photo";
})(AutoComplete || (AutoComplete = {}));
const DefaultTextFieldProps = {
    label: '',
    labelFixedAboveInput: false,
    size: Size.medium,
    type: InputType.text,
    autocomplete: AutoComplete.off,
    validationDisplay: ValidationDisplay.ErrorsOnly,
};
function Input(providedProps) {
    const props = mergeWithDefaults(providedProps, DefaultTextFieldProps);
    const { value, handleFocus, handleBlur, handleChange, handleKeyDown } = useStringValueInputHandlers(props, props.validation);
    const { placeholder, autocomplete, pattern } = props;
    return (_jsxs(SimpleInput, { onFocus: handleFocus, onBlur: handleBlur, onKeyUp: props.onKeyUp, onKeyDown: handleKeyDown, onChange: handleChange, onClick: props.onClick, type: props.type, value: value, label: props.label, disabled: props.disabled, className: props.className, autoFocus: props.autoFocus, placeholder: placeholder, autoComplete: autocomplete, pattern: pattern, wrapperRef: props.wrapperRef, styleProps: {
            $size: props.size,
            $validationState: getValidationState(props.validationDisplay, props.validation),
            $labelInsideInput: !props.labelFixedAboveInput,
        }, children: [props.children, _jsx(ValidationSection, { ...props })] }));
}
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=Input.js.map